// extracted by mini-css-extract-plugin
export default {"emailWrapper":"EditEmailModal-module__emailWrapper--3uB9n"};